import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../../services/httpService";
import { SideNav } from "components";
import HeaderDasNew from "components/core/headerDasNew";
import { SideNavContent } from "components";
import routes from "components/routes";
import {
  Ptag,
  LargeButton,
  Icons,
  BaseDropdown,
  MainBody,
} from "components/core";
import UploadFile from "components/UploadFile";
import { products, userplanIdFlex } from "utlis/utils";
import * as Styles from "./styles";
import { Divider } from "@mui/material";
import { theme } from "../../theme";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import PageHeader from "components/UniversalComponents/PageHeader";
import { WidthLimiter } from "pages/PlanSetup/styles";

const gmcDetails = JSON.parse(localStorage.getItem("gmc_details"));
const UploadPolicyDoc = () => {
  const [loading, setLoading] = useState(false);
  const [policyDocError, setpolicyDocError] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [policyDocErrorEmp, setpolicyDocErrorEmp] = useState(false);
  const [documentIdEmp, setDocumentIdEmp] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [polDocName, setPolDocName] = useState("");
  const [benefitManual, setBenefitManual] = useState("");
  const company_name = localStorage.getItem("company_name");
  const options = products();
  const showSidebar = () => {
    return !!localStorage.getItem("id");
  };
  const preUploadedFiles = useMemo(() => {
    let policyDoc = gmcDetails[selectedValue]?.policy_doc_url;
    let benefitsManual = gmcDetails[selectedValue]?.employee_policy_doc;
    policyDoc = policyDoc?.split("/").pop();
    benefitsManual = benefitsManual?.split("/").pop();
    setPolDocName(policyDoc);
    setBenefitManual(benefitsManual);
  }, [selectedValue]);
  let navigate = useNavigate();
  const savePlanIdAndNavigate = () => {
    navigate(`/${routes.CARE_DASHBOARD}`);
  };
  const handleSubmit = async () => {
    if (documentId === null && documentIdEmp == null) {
      alert("Please upload Policy Schedule.");
      return;
    }
    if (documentId === undefined && documentIdEmp === undefined) {
      savePlanIdAndNavigate();
      return;
    }

    var userplan_id = userplanIdFlex(selectedValue);
    let payload = {
      userplan_id: userplan_id,
    };
    if (documentId !== undefined) {
      payload.employer_document_id = documentId;
    }
    if (documentIdEmp !== undefined) {
      payload.employee_document_id = documentIdEmp;
    }
    // return;
    try {
      let { data } = await http.post(
        "/business/upload_policy_document/",
        payload
      );
      savePlanIdAndNavigate();
    } catch (ex) {
      console.log(ex?.response?.data);
      alert(ex);
    }
  };

  const renderSelectBox = () => {
    return (
      <>
        <Ptag
          fontSize="24px"
          fontWeight="600"
          letterHeight="1.33"
          letterSpacing="0.35px"
          style={{ paddingBottom: "30px" }}
        >
          Upload Policy Document
        </Ptag>
        <Styles.DropdownWrapper>
          <Styles.AgeWrapper
            id="idShown"
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            <option value="" selected disabled>
              Select Policy Document
            </option>
            {options.map((option) => (
              <Styles.Option key={option.value} value={option.value}>
                {option.label}
              </Styles.Option>
            ))}
          </Styles.AgeWrapper>
          <Icons
            style={{
              position: "absolute",
              marginLeft: "74%",
              paddingright: "3px",
              "pointer-events": "none",
            }}
            icon="chevron_down"
            fill={theme.primaryColor}
          />
        </Styles.DropdownWrapper>
      </>
    );
  };

  const updateSelectedValue = (value) => {
    setSelectedValue(value);
  };

  const getOptions = (options) => {
    return options.map((option) => ({
      ...option,
      title: option.label,
    }));
  };

  const renderForm = () => {
    return (
      <MainBody>
        <WidthLimiter>
          <Formik
            initialValues={{ policy_type: "" }}
            validationSchema={Yup.object().shape({
              policy_type: Yup.string().required("*Required"),
            })}
            onSubmit={handleSubmit}
          >
            {(formikProps) => (
              <>
                <Form>
                  <PageHeader header={"Upload Coverage Documents"} />
                  <div style={{ width: "50%", marginBottom: "2rem" }}>
                    {updateSelectedValue(formikProps.values?.policy_type)}
                    <BaseDropdown
                      fontSize="14"
                      fontColor={theme.defaultFontColor}
                      label="Select Product"
                      options={getOptions(options)}
                      formikProps={{ ...formikProps, name: "policy_type" }}
                    />
                  </div>
                  {/* {renderSelectBox()} */}
                  <UploadFile
                    label="Policy Schedule for Employer"
                    text="Upload File"
                    format="pdf"
                    type="policy_schedule"
                    onSelect={setDocumentId}
                    existingFileName={polDocName}
                    bottom="-5rem"
                  />
                  <Divider />
                  <UploadFile
                    label="Benefit Manual for Employees"
                    text="Upload PDF"
                    format="pdf"
                    type="benifit_manual"
                    onSelect={setDocumentIdEmp}
                    existingFileName={benefitManual}
                    bottom="-5rem"
                  />
                  <Styles.ButtonWrapper>
                    <LargeButton
                      id="business_about_next12"
                      textTransform="none"
                      label={"Update"}
                      type="submit"
                    />
                  </Styles.ButtonWrapper>
                </Form>
              </>
            )}
          </Formik>
        </WidthLimiter>
      </MainBody>
    );
    // setLoading(false)
  };

  return (
    <>
      <SideNav>{showSidebar() && <SideNavContent />}</SideNav>
      <HeaderDasNew company_name={company_name} />
      <Styles.Root>{renderForm()}</Styles.Root>
    </>
  );
};

export default UploadPolicyDoc;
